<template>
  <div class="proprietorNotificationEdit">
    <el-card>
      <div class="jump-btn">
        <el-button type="primary" @click="back">{{$t('lang.btn_returnNotif')}}</el-button>
      </div>
      <el-form :model="ruleForm" name="frm" :rules="rules" ref="ruleForm" class="wid100"
        :label-width="require('@/config/enum').c_ws4" :label-suffix="require('@/config/enum').c_colon">
        <!-- 通知类型 -->
        <el-form-item label="通知类型" prop="noticeType">
          <el-select v-model="ruleForm.noticeType" @change="handleNoticeTypeChange">
            <el-option v-for="item in noticeTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item tem :label="$t('lang.lab_titleNotif')" prop="title">
          <el-input v-model="ruleForm.title" :placeholder="$t('lang.lab_fillinNotification')" class="item-input"
            maxlength="15"></el-input>
        </el-form-item>
        <!-- 发送类型 -->
        <el-form-item :label="$t('lang.lab_sendType')" prop="sendType">
          <el-select v-model="ruleForm.sendType" :disabled="ruleForm.noticeType === 1"
            :placeholder="$t('lang.lab_selectSendType')" @change="sendTypeChange">
            <el-option key :label="$t('lang.lab_selectSendType')" value=""></el-option>
            <el-option v-for="item in sendTypes" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 楼单元房间 -->
        <el-row>
          <el-col :span='5'>
            <el-form-item :label="$t('lang.lab_sendRange')" prop="house" v-if="seen" class="item-select">
              <el-select v-model="ruleForm.house" :placeholder="$t('lang.lab_selectHouse')" @change="selectUnit">
                <el-option key :label="$t('lang.lab_selectHouse')" value=""></el-option>
                <el-option v-for="(item, index) in houses" :key="index" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='5'>
            <el-form-item prop="unit" v-if="seen" class="item-select">
              <el-select v-model="ruleForm.unit" :placeholder="$t('lang.lab_selectUnit')" @change="selectRoom">
                <el-option key :label="$t('lang.lab_selectUnit')" value=""></el-option>
                <el-option v-for="(item, index) in units" :key="index" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span='5' v-if="ruleForm.noticeType === 0">
            <el-form-item prop="room" v-if="seen" class="item-select">
              <el-select v-model="ruleForm.room" :placeholder="$t('lang.lab_selectRoom')">
                <el-option key :label="$t('lang.lab_selectRoom')" value=""></el-option>
                <el-option v-for="(item, index) in rooms" :key="index" :value="item.id" :label="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 分类 -->
        <el-form-item :label="$t('lang.lab_classify')" prop="classify">
          <el-select v-model="ruleForm.classify" :disabled="ruleForm.noticeType === 1"
            :placeholder="$t('lang.lab_selectClassify')">
            <el-option v-for="item in classifys" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 显示期限 -->
        <el-form-item :label="$t('lang.lab_displayDeadline')" v-if="ruleForm.noticeType === 0" prop="overdue">
          <el-radio-group v-model="ruleForm.overdue">
            <el-radio :label="0" @change="endToDate">{{$t('lang.lab_endToDate')}}</el-radio>
            <el-radio :label="1" @change="neverOutDate">{{$t('lang.lab_neverOutDate')}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重大事项开始时间 -->
        <el-form-item v-if="ruleForm.noticeType === 1" :label="$t('lang.lab_startTime')" prop="startTs">
          <el-date-picker v-model="ruleForm.startTs" type="datetime" placeholder="请选择开始时间" value-format="timestamp"
            :picker-options="pickerOptions0">
          </el-date-picker>
        </el-form-item>
        <!-- 过期时间 -->
        <el-form-item :label="$t('lang.lab_deadline')" prop="endTs" v-if="seen1">
          <el-date-picker v-model="ruleForm.endTs" type="datetime" :placeholder="$t('lang.lab_selectDeadline')"
            value-format="timestamp" :picker-options="pickerOptions0">
          </el-date-picker>
        </el-form-item>
        <!-- 重大事项图片上传 -->
        <el-form-item v-if="ruleForm.noticeType === 1" label="选择封面图片" prop="imageUrl" ref="imageUrl">
          <!-- <div style="color: cornflowerblue;font-weight: bold;">请选择封面图片</div> -->
          <div class="defaultAvatarList">
            <div class="defaultAvatarBox" v-for="(item,index) in defaultAvatar" :key="index"
              @click="selectDefaultImageUrl(item.url,index)">
              <el-image v-show="defaultImageUrlIndex===index" class="selectIcon"
                src="http://114.55.43.117:8090/getPicX/2023/11/14/202311140902597871885834.png"></el-image>
              <el-image class="defaultAvatarImg" :src="item.url"></el-image>
              <p class="defaultAvatarName" :class="defaultImageUrlIndex===index?'selectFont':''">{{item.name}}</p>
            </div>
          </div>
        </el-form-item>
        <!-- 内容 -->
        <el-form-item :label="$t('lang.lab_notification')" prop="content" class="editor-width">
          <quill-editor v-model="ruleForm.content" ref="myQuillEditor" :options="editorOption"
            @change="onEditorChange($event)"></quill-editor>
          <span class="editorText"
            v-show="isLength < 10001">{{$t('lang.lab_editor_tip1')}}{{isLength}}{{$t('lang.lab_editor_tip2')}}{{10000-isLength}}{{$t('lang.lab_editor_tip3')}}</span>
          <span class="editorTextTips" v-show="isLength >= 10001">{{$t('lang.lab_editor_tips')}}</span>
        </el-form-item>
        <!-- 按钮 -->
        <el-button class="btn-first" @click="resetForm('ruleForm')">{{$t('lang.btn_rest')}}</el-button>
        <el-button class="detailbtn" @click="save('ruleForm')" :disabled="isDisabled">{{$t('lang.btn_save')}}
        </el-button>
        <el-button class="detailbtn" type="primary" @click="submit('ruleForm')" :disabled="isDisabled">
          {{$t('lang.btn_saveAndSubmit')}}</el-button>
      </el-form>
    </el-card>
  </div>
</template>

<script>
  /**
   *@ClassName:proprietorNotificationEdit
   *@Description:业主通知-编辑/新增
   *@author:宋莎
   *@Copyright:格众科技
   *@date:2020-02-19
   */
  // 引入富文本title汉字
  import {
    addQuillTitle
  } from '../../../config/quill-title.js'
  import {
    mapGetters
  } from 'vuex'

  export default {
    data() {
      return {
        pickerOptions0: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 8.64e7
          }
        },
        saveData: '',
        seen: true, // 发送范围的显示
        seen1: true, // 显示期限的显示
        isDisabled: true, // 保存的可点击
        isFlag: false, // 编辑:true 新增：false
        isTrue: true, // 数据已定义
        isFalse: false, // 数据未定义
        isLength: 0, // 富文本字数长度
        rules: {
          title: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectTitleNotif'),
            trigger: 'blur'
          }],
          sendType: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectSendType'),
            trigger: 'change'
          }],
          classify: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectClassify'),
            trigger: 'change'
          }],
          overdue: [{
            required: true,
            message: this.$i18n.t('lang.lab_selectDisplayDeadline'),
            trigger: 'change'
          }],
          endTs: [{
            type: 'date',
            required: true,
            message: this.$i18n.t('lang.lab_selectDeadline'),
            trigger: 'blur'
          }],
          noticeType: [{
            required: true,
            message: '请选择通知类型',
            trigger: 'change'
          }],
          startTs: [{
            required: true,
            message: '请选择开始时间',
            trigger: 'blur'
          }],
          imageUrl: [{
            required: true,
            message: '请选择图片',
            trigger: 'change'
          }],
          content: [{
            required: true,
            validator: (rule, value, callback) => {
              if (this.ruleForm.noticeType === 1 && (!value || value.trim() === '')) {
                callback(new Error('请输入正文'))
              } else {
                callback()
              }
            },
            trigger: 'change'
          }]
        },
        ruleForm: {
          id: '', // 序号
          gardenId: '', // 小区范围
          pageSize: '', // 总页数
          sendType: 1, // 发送类型
          title: '', // 通知主题
          classify: 1, // 分类： 邻里活动、社区通知、业主福利 、温馨提示
          type: '', // 1: 楼 2：单元 3：房间
          house: '', // 楼号
          unit: '', // 单元号
          room: '', // 房间号
          content: '', // 通知正文
          overdue: 0, // 是否永久有效
          endTs: '', // 过期时间
          noticeType: 0, // 通知类型 0:普通通知 1:重大事项通知
          startTs: '', // 重大事项开始时间
          imageUrl: '', // 重大事项图片
        },
        tableData: [], // 全部小区
        houses: [], //  存储根据小区请求回来的楼号
        units: [], //  存储根据楼号请求回来的单元
        rooms: [], //  存储根据单元请求回来的房间号
        sendTypes: this.$i18n.t('lang.ProprietorNotificationEdit_sendTypes'), // 发送类型
        classifys: this.$i18n.t('lang.ProprietorNotificationEdit_classifys'), // 分类
        editorOption: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'], // 加粗，斜体，下划线，删除线
              ['blockquote', 'code-block'], // 引用，代码块
              [{
                header: 1
              }, {
                header: 2
              }], // 标题，键值对的形式；1、2表示字体大小
              [{
                list: 'ordered'
              }, {
                list: 'bullet'
              }], // 列表
              [{
                script: 'sub'
              }, {
                script: 'super'
              }], // 上下标
              [{
                indent: '-1'
              }, {
                indent: '+1'
              }], // 缩进
              [{
                direction: 'rtl'
              }], // 文本方向
              [{
                size: ['small', false, 'large', 'huge']
              }], // 字体大小
              [{
                header: [1, 2, 3, 4, 5, 6, false]
              }], // 几级标题
              [{
                color: []
              }, {
                background: []
              }], // 字体颜色，字体背景颜色
              [{
                font: []
              }], // 字体
              [{
                align: []
              }], // 对齐方式
              ['clean'], // 清除字体样式
              ['image', 'video'] // 上传图片、上传视频
            ]
          },
          theme: 'snow',
          placeholder: this.$i18n.t('lang.lab_text'),
        },
        noticeTypes: [{
            value: 0,
            label: '普通通知'
          },
          {
            value: 1,
            label: '重大事项通知'
          }
        ],
        defaultAvatar: [{
            name: '紧急通知',
            url: 'http://oss.kmyhwy.cn/2025/05/30/b260fe64-8361-4bf5-aad4-0b017b7867f8.png'
          },
          {
            name: '重要通知',
            url: 'http://oss.kmyhwy.cn/2025/05/30/b6fc6cd1-97ec-4afa-921e-f3824044d7fe.png'
          },
        ], // 默认图片list
        defaultImageUrlIndex: '', // 默认图片角标
      }
    },
    computed: {
      ...mapGetters(['gardenId']),
      editor() {
        return this.$refs.myQuillEditor.quill
      }
    },
    destroyed() {
      window.localStorage.setItem('yztzform', JSON.stringify(this.ruleForm))
      window.localStorage.setItem('yztzsaveData', JSON.stringify(this.saveData))
    },
    created() {
      this.gardenGrids(1, this.gardenId)
      // 判断编辑与新增
      this.isFlag = this.$route.query.flag
      if (window.localStorage.getItem('yztzform')) {
        this.ruleForm = JSON.parse(window.localStorage.getItem('yztzform'))
        if (window.localStorage.getItem('yztzsaveData')) {
          this.saveData = JSON.parse(window.localStorage.getItem('yztzsaveData'))
        }
      } else {
        if (this.$route.query.object) {
          // 转数字
          this.$route.query.object.houseId = Number(this.$route.query.object.houseId)
          this.$route.query.object.unitId = Number(this.$route.query.object.unitId)
          this.$route.query.object.roomId = Number(this.$route.query.object.roomId)
          // 如果任意值等于0，那么显示请选择字样
          if (this.$route.query.object.houseId === 0 && this.$route.query.object.noticeType == 0) {
            this.$route.query.object.houseId = ''
            this.$route.query.object.unitId = ''
            this.$route.query.object.roomId = ''
          } else if (this.$route.query.object.unitId === 0 && this.$route.query.object.noticeType == 0) {
            this.gardenGrids(2, this.$route.query.object.houseId)
            this.$route.query.object.unitId = ''
            this.$route.query.object.roomId = ''
          } else if (this.$route.query.object.roomId === 0 && this.$route.query.object.noticeType == 0) {
            this.gardenGrids(3, this.$route.query.object.unitId)
            this.$route.query.object.roomId = ''
          } else {
            // 获取下拉候选
            this.gardenGrids(2, this.$route.query.object.houseId)
            this.gardenGrids(3, this.$route.query.object.unitId)
          }
          // 判断显示
          this.sendTypeChange(this.$route.query.object.sendType)
          if (this.$route.query.object.overdue) {
            this.neverOutDate()
          } else {
            this.endToDate()
          }
          this.getData()
        } else {
          this.ruleForm.house = ''
          this.ruleForm.unit = ''
          this.ruleForm.room = ''
          this.ruleForm.content = ''
          this.endToDate()
          this.sendTypeChange(this.ruleForm.sendType)
        }
      }
    },
    watch: {
      ruleForm: {
        handler(newVal, oldVal) {
          // ruleForm数据变化时 会调用此方法
          let tempRule = JSON.stringify(newVal)
          if (tempRule === this.saveData) {
            // 没变
            this.isDisabled = true
          } else {
            // 变了
            this.isDisabled = false
          }
        },
        deep: true,
        immediate: true
      }
    },
    methods: {
      // 通知类型改变处理
      handleNoticeTypeChange(val) {
        this.ruleForm.noticeType = val
        if (val === 0) {
          // 普通通知
          this.ruleForm.startTs = ''
          this.ruleForm.imageUrl = ''
          this.ruleForm.classify = 1
          this.ruleForm.room = ''
        } else {
          // 重大事项通知
          this.seen1 = true
          this.ruleForm.overdue = 0
          this.ruleForm.endTs = ''
          this.ruleForm.room = ''
          this.ruleForm.classify = 2 // 默认分类为社区通知
          this.ruleForm.sendType = 1 // 默认发送范围为业主端
        }
      },
      // 选择封面图片
      selectDefaultImageUrl(item, index) {
        this.defaultImageUrlIndex = index
        this.ruleForm.imageUrl = item
      },
      validateTime() {
        if (this.ruleForm.noticeType === 1 && this.ruleForm.overdue === 0) {
          if (this.ruleForm.endTs && this.ruleForm.startTs) {
            if (this.ruleForm.endTs <= this.ruleForm.startTs) {
              this.$message.error('截止时间不能小于开始时间')
              return false
            }
          }
        }
        return true
      },
      // 业主通知编辑页面获取数据
      getData() {
        console.log('object', this.$route.query.object)
        // 这是用来双向绑定,由于字段名称不同，所以一一对应
        this.ruleForm.id = this.$route.query.object.id
        this.ruleForm.gardenId = this.gardenId
        this.ruleForm.title = this.$route.query.object.title
        this.ruleForm.sendType = this.$route.query.object.sendType
        this.ruleForm.content = this.$route.query.object.content
        this.ruleForm.house = this.$route.query.object.houseId
        this.ruleForm.unit = this.$route.query.object.unitId
        this.ruleForm.room = this.$route.query.object.roomId
        this.ruleForm.classify = this.$route.query.object.classify
        this.ruleForm.overdue = this.$route.query.object.overdue
        if (this.ruleForm.overdue === 0) {
          this.ruleForm.endTs = this.$route.query.object.endDate
        } else {
          this.ruleForm.endTs = ''
        }
        this.ruleForm.noticeType = this.$route.query.object.noticeType
        if (this.$route.query.object.noticeType === 1) {
          this.ruleForm.startTs = this.$route.query.object.startDate
          this.ruleForm.imageUrl = this.$route.query.object.imageUrl
          const index = this.defaultAvatar.findIndex(item => item.url === this.ruleForm.imageUrl)
          if (index !== -1) {
            this.defaultImageUrlIndex = index
          }
        }
        // 这是用来计算当前字符数，当有内容时，减去默认前后缀占位数
        var count = 0
        if (this.ruleForm.content != '') {
          count = 7
        }
        this.isLength = this.ruleForm.content.length - count
        console.log('getData', this.ruleForm)
        // 这是用来保存数据 用来保存就一进来取到的数据，不会去修改它
        this.saveData = JSON.stringify(this.ruleForm)
      },
      // 返回上一级
      back() {
        this.$router.push({
          name: 'proprietorNotificationList'
        })
      },
      // 发送类型变更
      sendTypeChange(value) {
        if (value != 1) {
          this.seen = false
          this.ruleForm.house = ''
          this.ruleForm.unit = ''
          this.ruleForm.room = ''
        } else {
          this.seen = true
        }
      },
      // 显示期限变更
      endToDate() {
        this.seen1 = true
      },
      neverOutDate() {
        this.seen1 = false
        this.ruleForm.endTs = ''
      },
      // id查询楼号楼层房间号
      gardenGrids(type, id) {
        if (id === '') return
        this.$get(`/gardenGrids/?type=${type}&parentId=${id}&pageNo=1&pageSize=9999`).then(
          res => {
            if (res && res.errCode === 0) {
              if (type === 1) {
                this.houses = res.list
              } else if (type === 2) {
                this.units = res.list
              } else if (type === 3) {
                this.rooms = res.list
              }
            }
          },
          error => {
            this.$message.error(error)
          }
        )
      },
      // 根据小区选择获取楼号
      selectHouse(id) {
        this.type = 1
        this.ruleForm.house = ''
        this.ruleForm.unit = ''
        this.ruleForm.room = ''
        this.houses = []
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据楼号选择获取单元
      selectUnit(id) {
        this.type = 2
        this.ruleForm.unit = ''
        this.ruleForm.room = ''
        this.units = []
        this.rooms = []
        this.gardenGrids(this.type, id)
      },
      // 根据单元选择获取房间
      selectRoom(id) {
        this.type = 3
        this.rooms = []
        this.ruleForm.room = ''
        this.gardenGrids(this.type, id)
      },
      // 保存
      save(formName) {
        console.log('save', this.ruleForm)
        let params = {}
        if (this.isFlag) {
          params.id = this.ruleForm.id
        }
        params.gardenId = this.gardenId
        if (this.ruleForm.type === null || this.ruleForm.type === undefined || this.ruleForm.type === '') {
          params.type = 2
        } else {
          params.type = this.ruleForm.type
        }
        params.title = this.ruleForm.title
        params.sendType = this.ruleForm.sendType
        params.content = this.ruleForm.content
        if (this.ruleForm.house === null || this.ruleForm.house === undefined || this.ruleForm.house === '' || this
          .ruleForm.sendType != 1) {
          params.house = 0
        } else {
          params.house = this.ruleForm.house
        }
        if (this.ruleForm.unit === null || this.ruleForm.unit === undefined || this.ruleForm.unit === '' || this
          .ruleForm.sendType != 1) {
          params.unit = 0
        } else {
          params.unit = this.ruleForm.unit
        }
        if (this.ruleForm.room === null || this.ruleForm.room === undefined || this.ruleForm.room === '' || this
          .ruleForm.sendType != 1) {
          params.room = 0
        } else {
          params.room = this.ruleForm.room
        }
        params.classify = this.ruleForm.classify
        params.overdue = this.ruleForm.overdue
        if (this.ruleForm.overdue === 0) {
          params.endTs = this.ruleForm.endTs
        }
        params.noticeType = this.ruleForm.noticeType
        if (this.ruleForm.noticeType === 1) {
          params.startTs = this.ruleForm.startTs
          params.imageUrl = this.ruleForm.imageUrl
        }
        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.validateTime()) {
              return false
            }
            let loading = this.$loading()
            this.$post('/notice/NoticeAjaxSave', params).then(
              res => {
                loading.close()
                if (res && res.errCode === 0) {
                  this.$message.success(this.$i18n.t('lang.lab_save_success'))
                  this.$router.push({
                    name: 'proprietorNotificationList'
                  })
                }
              },
              error => {
                loading.close()
                this.$message.error(error)
              }
            )
          } else {
            return false
          }
        })
      },
      // 保存并发布
      submit(formName) {
        console.log('submit', this.ruleForm)
        let params = {}
        params.gardenId = this.gardenId
        if (this.ruleForm.type === null || this.ruleForm.type === undefined || this.ruleForm.type === '') {
          params.type = 2
        } else {
          params.type = this.ruleForm.type
        }
        params.title = this.ruleForm.title
        params.sendType = this.ruleForm.sendType
        params.content = this.ruleForm.content
        if (this.ruleForm.house === null || this.ruleForm.house === undefined || this.ruleForm.house === '' || this
          .ruleForm.sendType != 1) {
          params.house = 0
        } else {
          params.house = this.ruleForm.house
        }
        if (this.ruleForm.unit === null || this.ruleForm.unit === undefined || this.ruleForm.unit === '' || this
          .ruleForm.sendType != 1) {
          params.unit = 0
        } else {
          params.unit = this.ruleForm.unit
        }
        if (this.ruleForm.room === null || this.ruleForm.room === undefined || this.ruleForm.room === '' || this
          .ruleForm.sendType != 1) {
          params.room = 0
        } else {
          params.room = this.ruleForm.room
        }
        params.classify = this.ruleForm.classify
        params.overdue = this.ruleForm.overdue
        if (this.ruleForm.overdue === 0) {
          params.endTs = this.ruleForm.endTs
        }
        params.noticeType = this.ruleForm.noticeType
        if (this.ruleForm.noticeType === 1) {
          params.startTs = this.ruleForm.startTs
          params.imageUrl = this.ruleForm.imageUrl
        }

        console.log('params', params)
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.validateTime()) {
              return false
            }
            let loading = this.$loading()
            if (this.isFlag) {
              this.$patch(`/notices/${this.ruleForm.id}`, params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_modify_success'))
                    this.$router.push({
                      name: 'proprietorNotificationList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            } else {
              this.$post('/notices', params).then(
                res => {
                  loading.close()
                  if (res && res.errCode === 0) {
                    this.$message.success(this.$i18n.t('lang.lab_saveAndSubmit_success'))
                    this.$router.push({
                      name: 'proprietorNotificationList'
                    })
                  }
                },
                error => {
                  loading.close()
                  this.$message.error(error)
                }
              )
            }
          } else {
            return false
          }
        })
      },
      // 清空
      resetForm(formName) {
        this.$refs.ruleForm.clearValidate()
        this.ruleForm.sendType = 1 // 发送类型
        this.ruleForm.title = '' // 通知主题
        this.ruleForm.classify = 1 // 分类： 邻里活动、社区通知、业主福利 、温馨提示
        this.ruleForm.type = '' // 1：楼 2：单元 3：房间
        this.ruleForm.house = '' // 楼号
        this.ruleForm.unit = '' // 单元号
        this.ruleForm.room = '' // 房间号
        this.ruleForm.content = '' // 通知正文
        this.ruleForm.overdue = 0 // 是否永久有效
        this.ruleForm.endTs = '' // 过期时间
        this.ruleForm.startTs = '' // 开始时间
      },
      // 内容字数提示
      onEditorChange(event) {
        event.quill.deleteText(10000, 4)
        if (this.ruleForm.content === '') {
          this.isLength = 0
        } else {
          this.isLength = event.quill.getLength() - 1
        }
      },
    },
    // 富文本字数限制显示位置
    mounted() {
      addQuillTitle()
    }
  }
</script>

<style lang="scss">
  .proprietorNotificationEdit {
    .item-input {
      width: 30%;
    }

    .editor-width {
      width: 80%;
    }

    .item-select {
      display: inline-block
    }

    .empty-input {
      display: none
    }

    .defaultAvatarList {
      display: flex;
      flex-wrap: wrap;

      .defaultAvatarBox {
        width: 148px;
        height: 148px;
        margin-right: 10px;
        position: relative;
        margin-bottom: 10px;
        padding-bottom: 40px;
        text-align: center;
      }

      .selectIcon {
        width: 52px;
        height: 52px;
        position: absolute;
        right: -6px;
        top: -9px;
        z-index: 100;
      }

      .selectFont {
        color: #13ce66;
        font-weight: bold;
      }

      .defaultAvatarImg {
        width: 100%;
        height: 100%;
      }

      .defaultAvatarName {
        margin-top: -15px;
      }

      .handUpload {
        width: 148px;
        height: 148px;
        line-height: 148px;
        border: 1px dashed #c0ccda;
        text-align: center;
        color: #c0ccda;
        font-weight: bold;
        font-size: 16px;
      }

      .handUpload:hover {
        border: 1px dashed #00b1c3;
        color: #00b1c3;
      }
    }
  }
</style>
